export default "__VITE_ASSET__7VXGQm$C__"